export const moveAppAction = async (direction: 'up' | 'down' | 'left' | 'right') => {
    if (!window.electronApi) {
        return;
    }

    // @TODO: Remove
    if (typeof window.electronApi.moveApp === 'undefined') {
        return;
    }

    window.electronApi.moveApp(direction, 50);
};
